(() => {
  'use strict';

  if (customElements.get('dieux-related-articles')) return;

  class DieuxRelatedArticles extends HTMLElement {
    connectedCallback() {
      this.abortController?.abort();
      this.abortController = new AbortController();
      const { signal } = this.abortController;
      this.responsiveMode = this.getResponsiveMode();

      window.addEventListener('dieux:swiper:ready', this.mountCarousel, { signal });

      this.metricsObserver = new ResizeObserver(this.scheduleMetrics);
      this.metricsObserver.observe(this);

      this.mountCarousel();
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.metricsObserver?.disconnect();
      this.metricsObserver = null;
      cancelAnimationFrame(this.metricsFrame || 0);
      this.metricsFrame = 0;
      this.carouselController?.destroy();
      this.carouselController = null;
    }

    getResponsiveMode() {
      const frame = this.querySelector('[data-related-articles-carousel]');
      return (
        getComputedStyle(frame || this)
          .getPropertyValue('--related-articles-responsive-mode')
          .trim() || 'grid'
      );
    }

    scheduleMetrics = () => {
      if (this.metricsFrame) return;
      this.metricsFrame = requestAnimationFrame(() => {
        this.metricsFrame = 0;
        if (!this.isConnected) return;
        if (this.getResponsiveMode() !== this.responsiveMode) {
          this.mountCarousel();
          return;
        }
        this.carouselController?.refresh(false);
      });
    };

    mountCarousel = () => {
      if (!this.isConnected) return;
      this.responsiveMode = this.getResponsiveMode();
      this.carouselController?.destroy();
      this.carouselController = null;

      const viewport = this.querySelector('[data-related-articles-viewport]');
      if (this.responsiveMode !== 'rail') {
        this.dataset.swiperState = 'static';
        if (viewport instanceof HTMLElement) viewport.scrollLeft = 0;
        return;
      }

      const track = this.querySelector('[data-related-articles-track]');
      if (
        !(viewport instanceof HTMLElement)
        || !(track instanceof HTMLElement)
        || !window.DieuxSwiper
      ) {
        return;
      }

      this.carouselController = window.DieuxSwiper.mount({
        owner: this,
        viewport,
        track,
        stateTarget: this,
        previousButton: this.querySelector('[data-swiper-button="previous"]'),
        nextButton: this.querySelector('[data-swiper-button="next"]'),
        mousewheel: true,
        gapProperty: '--related-articles-gap-current',
        gapSource: this,
        options: {
          slidesPerView: 'auto',
          a11y: {
            enabled: false,
          },
        },
        onStateChange: ({ state, controller }) => {
          if (state === 'enhanced') requestAnimationFrame(() => controller.refresh());
        },
      });
    };
  }

  customElements.define('dieux-related-articles', DieuxRelatedArticles);
})();
